// PK Product Layout Script
// Moves .product__artist-line into the reviews block so it sits inline with stars
// Works on all screen sizes — no mobile-only condition
(function () {
  function init() {
    var artist = document.querySelector('.product__artist-line');
    if (!artist) return;
    var titleRow = artist.closest('.pk-title-artist-row');
    if (!titleRow) return;
    var reviewsBlock = titleRow.nextElementSibling;
    if (!reviewsBlock) return;
    reviewsBlock.insertBefore(artist, reviewsBlock.firstChild);
    reviewsBlock.classList.add('pk-artist-reviews-bar');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
